import ChoosePlan from "features/settings/Subscription/ChoosePlan";
import { usePageIntro } from "common/NewLook";
import styled, { css, useTheme } from "styled-components";
import StepWithSummary from "features/settings/Subscription/StepWithSummary";
import { PAGE_SPINNER_MARGIN_FROM_TOP } from "common/constants";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { useIsSmallMobileCheckout } from "features/settings/common/hooks";
import { SUBSCRIPTION_STEPS } from "@shared/features/settings/subscription/types";
import Drawer from "common/Drawers/Drawer.tsx";
import { useContext } from "react";
import { BuySubscriptionContext } from "features/settings/Subscription/BuySubscription.context";
import BuySubscriptionProvider from "features/settings/Subscription/BuySubscriptionProvider.tsx";

const BuySubscription = () => (
  <BuySubscriptionProvider>
    <InnerBuySubscription />
  </BuySubscriptionProvider>
);

export default BuySubscription;

const InnerBuySubscription = () => {
  const theme = useTheme();
  // Focused flow with its own title and back button.
  usePageIntro({ hidden: theme.isNewLook }, [theme.isNewLook]);
  const {
    subscriptionParams,
    plans,
    plan,
    previousStep,
    isExtend,
    isFetching,
    isLoading,
    isBottomSummary: isDrawerPayment,
  } = useContext(BuySubscriptionContext)!;
  const isChoosePlan = subscriptionParams.step === SUBSCRIPTION_STEPS.PLAN;
  const isSmallMobile = useIsSmallMobileCheckout();

  const showChoosePlan =
    !!plans && (isChoosePlan || (!isExtend && isDrawerPayment));
  const choosePlan = showChoosePlan && <ChoosePlan />;

  const stepWithSummary = !!plans && plan && !isChoosePlan && (
    <StepWithSummary />
  );

  return (
    <Wrapper>
      <LoadingSpinnerOverlay
        isLoading={isFetching || isLoading}
        hideContentWhileLoading={isLoading}
        spinnerMarginTop={PAGE_SPINNER_MARGIN_FROM_TOP}
        spinnerSize="large"
        backgroundColor={theme.colors.layoutBgColor}
      >
        {!isDrawerPayment && stepWithSummary}
        {choosePlan}
        {isDrawerPayment && (
          <StyledDrawer
            open={!isChoosePlan}
            styles={{ body: { position: "relative", padding: 0 } }}
            // New look: the drawer's own close stays, on the title row.
            closeIcon={isSmallMobile && !theme.isNewLook ? null : undefined}
            onClose={previousStep}
          >
            {stepWithSummary}
          </StyledDrawer>
        )}
      </LoadingSpinnerOverlay>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  flex: 1;
  background-color: ${(p) => p.theme.colors.bgColor};
  ${(p) =>
    p.theme.isNewLook &&
    css`
      /* The page canvas shows through, so the plan panels read as panels. */
      background-color: transparent;
    `}
`;
const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding-bottom: 0 !important;
  }
`;
